import { createSelector } from "reselect";
import startCase from "lodash/startCase";
import { ServiceProvider } from "../interfaces/ServiceProvidersInterface";
import { RootState } from "../store";

// selectors
export const spFullNameSelector = (
  serviceProvider: { title: string; firstName: string; lastName: string } = {
    title: "",
    firstName: "",
    lastName: ""
  }
): string => {
  const { title, firstName, lastName } = serviceProvider;
  return `${startCase(title)} ${startCase(firstName)} ${startCase(lastName)}`;
};

export const spFullNameSelectorWithNmc = (serviceProvider: Partial<ServiceProvider>): string => {
  const { title, firstName, lastName, registrationNumber, speciality } = serviceProvider;

  const name = [title, firstName, lastName].filter(Boolean).map(startCase).join(" ");
  const nmc = registrationNumber ? `(NMC No. ${registrationNumber})` : "";
  const spec = speciality ? startCase(speciality) : "";

  if (nmc && spec) return `${name} ${nmc}, ${spec}`;
  if (nmc) return `${name} ${nmc}`;
  if (spec) return `${name}, ${spec}`;

  return name;
};

export const spFromIdSelector = (
  SPs: ServiceProvider[],
  id: number | null
): ServiceProvider | undefined => {
  if (!SPs || !id) return undefined;
  return SPs.find((item) => Number(id) === Number(item.id)) ?? undefined;
};

export const serviceProvidersSelector = (state: RootState): ServiceProvider[] =>
  state.resources.resourceCentreServiceProviders;

export const activeServiceProviders = createSelector(serviceProvidersSelector, (SPs) =>
  SPs.filter(({ active }) => active)
);

export const serviceProvidersSortedSelector = createSelector(activeServiceProviders, (SPs) =>
  SPs.sort((a, b) =>
    `${a.firstName || ""}${a.lastName || ""}`.toLowerCase() >
    `${b.firstName || ""}${b.lastName || ""}`.toLowerCase()
      ? 1
      : -1
  )
);
